import { useTranslation } from "react-i18next"
import { Dialog, DialogProps } from "../ui/Dialog"
import { Button } from "../ui/Button"
import { importStyleCreationPreset } from "@/store/store-presets"
import { PresetItem } from "@/store/presets/presets-service"
import toast from "react-hot-toast"
import { isAbortError } from "@/utils/error"
import { Sentry } from "@/telemetry/sentry"

export const UploadPresetDialog = (
	props: DialogProps & {
		onContinue: () => void
		onSelect?: (preset: PresetItem) => void
	},
) => {
	const { t } = useTranslation("components")

	const handleUploadPreset = async () => {
		try {
			const result = await importStyleCreationPreset()
			const error = Object.values(result.errors)[0]
			if (error) {
				toast.error(t("uploadPresetDialog.unableToImportPresetPlease"))
				return
			}

			const preset = result?.presets[0]
			if (preset && props.onSelect) {
				props.onSelect(preset)
			}
		} catch (e) {
			if (isAbortError(e)) {
				return
			}
			Sentry.captureException(e)
			toast.error(t("uploadPresetDialog.unableToImportPresetPlease2"))
		}
	}

	const handleContinueWithoutPreset = () => {
		props.onContinue()
	}

	return (
		<Dialog
			{...props}
			disableClose={false}
			canGoBack={true}
			trackingViewName="upload_preset_dialog"
		>
			<div className="flex h-fit w-[512px] flex-col space-y-3">
				<div className="text-start text-md font-bold">
					{t("uploadPresetDialog.uploadPreset")}
				</div>

				<div className="pb-2 text-start text-sm">
					{t("uploadPresetDialog.uploadDescription")}
				</div>

				<div className="flex w-full flex-1 flex-row items-center justify-end space-x-2">
					<Button
						trackingLabel="continue_without_preset"
						aria-label={t("uploadPresetDialog.ariaContinueWithoutPreset")}
						onClick={handleContinueWithoutPreset}
						variant="default"
					>
						{t("uploadPresetDialog.continueWithoutPreset")}
					</Button>
					<Button
						trackingLabel="upload_preset"
						aria-label={t("uploadPresetDialog.ariaUploadPreset")}
						onClick={() => void handleUploadPreset()}
						variant="primary"
					>
						{t("uploadPresetDialog.uploadPreset")}
					</Button>
				</div>
			</div>
		</Dialog>
	)
}
